<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Account Settings
              </router-link>
            </li>

            

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Lien social
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-transports"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Transports
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="d-flex align-items-center gap-3">
                  <!-- User Image -->
                  <div class="image position-relative">
                    <img
                      :src="logoPreview || require('@/assets/images/NoImage.png')"
                      class="rounded-circle"
                      width="85"
                      height="85"
                      
                    />
                  </div>

                  <!-- File Input -->
                  <div class="form-group mb-0">
                    <label class="d-block text-black fw-semibold mb-10">
                      Importer votre logo
                    </label>
                    <input
                      class="form-control fs-15 text-black shadow-none"
                      type="file"
                      id="formFile"
                       accept="image/*"
                      @change="onFileChangeLogo"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom de la société
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    :class="{ 'is-invalid': errors.name }"
                    placeholder="e.g. Acme Corp"
                    maxlength="100"
                    v-model="settingData.name"
                  />
                  <div v-if="errors.name" class="invalid-feedback">{{ errors.name }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Site web
                  </label>
                  <input
                    type="url"
                    class="form-control shadow-none rounded-0 text-black"
                    :class="{ 'is-invalid': errors.website }"
                    placeholder="https://example.com"
                    maxlength="255"
                    v-model="settingData.website"
                  />
                  <div v-if="errors.website" class="invalid-feedback">{{ errors.website }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    :class="{ 'is-invalid': errors.email }"
                    placeholder="contact@example.com"
                    maxlength="150"
                    v-model="settingData.email"
                  />
                  <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <input
                    type="tel"
                    class="form-control shadow-none rounded-0 text-black"
                    :class="{ 'is-invalid': errors.phone }"
                    placeholder="+212 600 000000"
                    maxlength="20"
                    v-model="settingData.phone"
                  />
                  <div v-if="errors.phone" class="invalid-feedback">{{ errors.phone }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Ville
                  </label>
                  <select
                    class="form-select shadow-none fw-semibold rounded-0"
                    v-model="settingData.siege"
                  >
                    <option
                      v-for="option in cities"
                      :key="option.id"
                      :value="option.name"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Choisir votre devis
                  </label>
                  <select class="form-select shadow-none fw-semibold rounded-0">
                    <option value="MAD">MAD</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                  </select>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <textarea
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="settingData.adresse"
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Les conditions générales
                  </label>
                  <textarea
                    rows="15"
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="settingData.conditions"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Enregistrer
                  </button>
                  <!-- <button
                    type="button"
                    class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                  >
                    <i
                      class="flaticon-delete lh-1 me-1 position-relative top-2"
                    ></i>
                    <span class="position-relative">Cancel</span>
                  </button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();
    const { sanitizeText, sanitizeUrl } = useSanitize();

    const modules = {
      module: BlotFormatter,
      ImageUploader,
      options: {
        upload: (file: string | Blob) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("/upload-image", formData)
              .then((res: { data: { url: unknown } }) => {
                console.log(res);
                resolve(res.data.url);
              })
              .catch((err: unknown) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
    };

    const logoPreview = ref<string | null>(null);
    const logoFile = ref<File | null>(null);
    const settingData = reactive<Record<string, any>>({});
    const cities = ref<any[] | null>(null);
    const errors = reactive<Record<string, string>>({});

    function validateForm(): boolean {
      Object.keys(errors).forEach(k => delete errors[k]);

      if (!settingData.name?.trim())
        errors.name = 'Le nom de la société est obligatoire.';
      else if (settingData.name.trim().length > 100)
        errors.name = 'Maximum 100 caractères.';

      if (settingData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(settingData.email))
        errors.email = 'Adresse email invalide.';

      if (settingData.phone && !/^[\d\s+\-().]{6,20}$/.test(settingData.phone))
        errors.phone = 'Numéro de téléphone invalide (chiffres, +, -, espaces uniquement).';

      if (settingData.website) {
        const safe = sanitizeUrl(settingData.website);
        if (!safe || !/^https?:\/\/.+/.test(safe))
          errors.website = 'URL invalide. Doit commencer par https:// ou http://';
      }

      return Object.keys(errors).length === 0;
    }

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/general_list`);
        Object.assign(settingData, response.data);
        if (response.data.logo) {
          logoPreview.value = response.data.logo;
        }
      } catch (error) {
        console.error("Error fetching user account:", error);
      }

      try {
        const response = await api.get(`/api/auth/citiesList`);
        cities.value = response.data; // ✅ assign to .value
        // console.log("Fetched cities:", cities.value);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    const onFileChangeLogo = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;

      const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
      const MAX_SIZE_MB = 2;

      if (!ALLOWED_TYPES.includes(file.type)) {
        showToast('Format non autorisé. Utilisez JPG, PNG, WEBP ou GIF.', 'error');
        input.value = '';
        return;
      }

      if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        showToast(`L'image ne doit pas dépasser ${MAX_SIZE_MB} Mo.`, 'error');
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const MAX_W = 200;
          const MAX_H = 60;
          const ratio = Math.min(MAX_W / img.width, MAX_H / img.height);
          const w = Math.round(img.width * ratio);
          const h = Math.round(img.height * ratio);

          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d')!;
          ctx.drawImage(img, 0, 0, w, h);

          logoPreview.value = canvas.toDataURL('image/png');

          canvas.toBlob((blob) => {
            if (blob) {
              logoFile.value = new File([blob], 'logo.png', { type: 'image/png' });
            }
          }, 'image/png');
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    };

    // Submit form
    async function submitForm() {
      if (!validateForm()) return;

      try {
        const formData = new FormData();
        const appendIfPresent = (key: string, value: string) => {
          if (value) formData.append(key, value);
        };

        appendIfPresent("name", sanitizeText(settingData.name));
        appendIfPresent("website", sanitizeUrl(settingData.website || ''));
        appendIfPresent("email", sanitizeText(settingData.email));
        appendIfPresent("phone", sanitizeText(settingData.phone));
        appendIfPresent("siege", sanitizeText(settingData.siege));
        appendIfPresent("devis", sanitizeText(settingData.devis));
        appendIfPresent("adresse", sanitizeText(settingData.adresse));
        appendIfPresent("conditions", sanitizeText(settingData.conditions));

        if (logoFile.value) {
          formData.append("logo", logoFile.value);
        }

        const response = await api.post("/api/auth/general_add", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.success) {
          showToast("Paramètres sauvegardés avec succès!", "success");
        } else {
          showToast("Erreur: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue lors de la sauvegarde.", "error");
      }
    }

    return {
      modules,
      logoPreview,
      cities,
      settingData,
      errors,
      onFileChangeLogo,
      submitForm,
    };
  },
});
</script>